/* ESTEÉ PARIS — PDP interactions */
/* EP i18n V20: vertaalde teksten via window.EP_I18N (snippet ep-i18n) */
window.epT = window.epT || function (k, fb) { var d = window.EP_I18N || {}; return (typeof d[k] === 'string' && d[k] !== '') ? d[k] : fb; };
(function() {
  'use strict';

  // ===== Gallery =====
  document.querySelectorAll('[data-ep-gallery]').forEach(gallery => {
    const imgs = gallery.querySelectorAll('.ep-gallery-img');
    const dots = gallery.querySelectorAll('.ep-dot-thumb');
    const counter = gallery.querySelector('[data-ep-counter]');
    let idx = 0;
    const go = n => {
      idx = (n + imgs.length) % imgs.length;
      imgs.forEach((im, i) => im.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      if (counter) counter.textContent = String(idx+1).padStart(2,'0') + ' / ' + String(imgs.length).padStart(2,'0');
    };
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
const prevBtn = gallery.querySelector('[data-ep-prev]');
const nextBtn = gallery.querySelector('[data-ep-next]');
if (prevBtn) prevBtn.addEventListener('click', () => go(idx - 1));
if (nextBtn) nextBtn.addEventListener('click', () => go(idx + 1));

    // Swipe
    let sx = 0;
    gallery.addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
    gallery.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
    });
  });

  // ===== Countdown =====
  document.querySelectorAll('[data-ep-countdown]').forEach(el => {
    const endAttr = el.dataset.end;
    // Format: "YYYY-MM-DDTHH:MM" in store timezone, OR "+Nh" for rolling
    let end;
    if (endAttr && endAttr.startsWith('+')) {
      const hrs = parseInt(endAttr.slice(1), 10) || 24;
      const key = 'ep-countdown-' + el.dataset.id;
      const stored = parseInt(localStorage.getItem(key) || '0', 10);
      if (stored && stored > Date.now()) end = stored;
      else {
        end = Date.now() + hrs * 3600 * 1000;
        localStorage.setItem(key, String(end));
      }
    } else {
      end = new Date(endAttr).getTime();
    }

    const h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    const pad = n => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      const hh = Math.floor(diff / 3600000);
      const mm = Math.floor((diff % 3600000) / 60000);
      const ss = Math.floor((diff % 60000) / 1000);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
    };
    tick();
    setInterval(tick, 1000);
  });

  // ===== Live viewers =====
  document.querySelectorAll('[data-ep-viewers]').forEach(el => {
    let v = parseInt(el.dataset.base || '40', 10);
    const render = () => el.textContent = v;
    render();
    setInterval(() => {
      v = Math.max(20, Math.min(80, v + Math.round((Math.random() - 0.5) * 6)));
      render();
    }, 3500);
  });

  // ===== Variant picker (color + size) =====
  const form = document.querySelector('[data-ep-product-form]');
  if (form) {
    const productData = JSON.parse(document.querySelector('[data-ep-product-json]').textContent);
    const idInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-ep-price]');
    const oldPriceEl = document.querySelector('[data-ep-price-old]');
    const atcBtn = form.querySelector('[data-ep-atc]');
    const atcPriceEl = form.querySelector('[data-ep-atc-price]');

    const selected = {};
    productData.options.forEach(o => selected[o] = null);

    const findVariant = () => productData.variants.find(v =>
      productData.options.every((opt, i) => v.options[i] === selected[opt])
    );

    const fmt = cents => {
      const n = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + n;
    };

    const updateUI = () => {
      const v = findVariant();
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (oldPriceEl && v.compare_at_price && v.compare_at_price > v.price) {
          oldPriceEl.textContent = fmt(v.compare_at_price);
          oldPriceEl.style.display = '';
        } else if (oldPriceEl) {
          oldPriceEl.style.display = 'none';
        }
        atcBtn.disabled = !v.available;
        atcBtn.querySelector('[data-ep-atc-label]').textContent = v.available ? epT('atc', 'Ajouter au panier') : epT('sold_out', 'Épuisé');
        if (atcPriceEl) {
          const qty = parseInt(form.querySelector('[name="quantity"]').value || '1', 10);
          atcPriceEl.textContent = '· ' + fmt(v.price * qty);
        }
      } else {
        atcBtn.disabled = true;
      }
    };

    form.querySelectorAll('[data-ep-option]').forEach(btn => {
      btn.addEventListener('click', () => {
        const opt = btn.dataset.epOption;
        const val = btn.dataset.epValue;
        selected[opt] = val;
        try { if (window.posthog) posthog.capture('variant_selected', { option: opt, value: val }); } catch(e){}
        form.querySelectorAll('[data-ep-option="' + opt + '"]').forEach(b => {
          b.classList.toggle('is-active', b.dataset.epValue === val);
        });
        // Update label
        const labelEl = document.querySelector('[data-ep-option-label="' + opt + '"]');
        if (labelEl) labelEl.textContent = val;
         // Wissel gallery naar variant afbeelding
        if (btn.dataset.epSwatchImgId) {
          const allImgs = Array.from(document.querySelectorAll('.ep-gallery-img'));
          const dots = document.querySelectorAll('.ep-dot-thumb');
          const counter = document.querySelector('[data-ep-counter]');
          const targetIdx = allImgs.findIndex(img => img.dataset.epImgId === btn.dataset.epSwatchImgId);
          if (targetIdx !== -1) {
            allImgs.forEach((im, j) => im.classList.toggle('is-active', j === targetIdx));
            dots.forEach((d, j) => d.classList.toggle('is-active', j === targetIdx));
            if (counter) counter.textContent = String(targetIdx+1).padStart(2,'0') + ' / ' + String(allImgs.length).padStart(2,'0');
          }
        }
      
        updateUI();
      });
    });

    updateUI();

    // Bundle quantity controls ATC total + line item property
    form.querySelectorAll('[data-ep-bundle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const qty = parseInt(btn.dataset.epBundle, 10);
        form.querySelectorAll('[data-ep-bundle]').forEach(b => b.classList.toggle('is-selected', b === btn));
        form.querySelector('[name="quantity"]').value = qty;
        updateUI();
        // update free-ship progress
        const v = findVariant();
        if (v) {
          const total = v.price * qty / 100;
          const threshold = parseInt(form.dataset.freeshipThreshold || '80', 10);
          const pct = Math.min(100, (total / threshold) * 100);
          const fill = document.querySelector('[data-ep-ship-fill]');
          const remaining = document.querySelector('[data-ep-ship-remaining]');
          if (fill) fill.style.width = pct + '%';
          if (remaining) remaining.textContent = Math.max(0, threshold - total).toFixed(0);
        }
      });
    });

// Sticky ATC shows when main ATC scrolls off
const mainBtn = document.querySelector('[data-ep-atc]');
const sticky = document.querySelector('[data-ep-sticky]');
if (mainBtn && sticky) {
  let cartOpen = false;
  const io = new IntersectionObserver(([e]) => {
    if (!cartOpen) sticky.classList.toggle('is-visible', !e.isIntersecting);
  }, { threshold: 0 });
  io.observe(mainBtn);
  document.addEventListener('ajaxProduct:added', () => {
    cartOpen = true;
    sticky.classList.remove('is-visible');
  });
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    new MutationObserver(() => {
      const isOpen = cartDrawer.classList.contains('drawer--is-open');
      cartOpen = isOpen;
      if (isOpen) sticky.classList.remove('is-visible');
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
}



  }

  // ===== Size quiz =====
  const quizBg = document.querySelector('[data-ep-quiz-bg]');
  const quiz = document.querySelector('[data-ep-quiz]');
  const openQuizBtns = document.querySelectorAll('[data-ep-open-quiz]');
  const closeQuiz = document.querySelector('[data-ep-close-quiz]');
  const openQuiz = () => { quizBg?.classList.add('is-open'); quiz?.classList.add('is-open'); try { if (window.posthog) posthog.capture('size_quiz_opened'); } catch(e){} };
  const hideQuiz = () => { quizBg?.classList.remove('is-open'); quiz?.classList.remove('is-open'); };
  openQuizBtns.forEach(b => b.addEventListener('click', openQuiz));
  closeQuiz?.addEventListener('click', hideQuiz);
  quizBg?.addEventListener('click', hideQuiz);

  if (quiz) {
    const steps = quiz.querySelectorAll('[data-ep-quiz-step]');
    let step = 0;
    const answers = {};
                const sizes = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    // Per-product maattabel: alleen gevuld bij producten met custom.size_chart.
    const chartSizes = (quiz.dataset.epChartSizes || '').split('|').filter(Boolean);
    const chartBust = (quiz.dataset.epChartBust || '').split('|')
      .map(function (v) { return parseFloat(String(v).replace(',', '.')); });
    const useChart = chartSizes.length > 1 && chartBust.length === chartSizes.length &&
                     chartBust.every(function (n) { return !isNaN(n); });
    // Tour de poitrine (cm) per gekozen EU-maat 34/36/38/40/42/44 - zelfde bron als de
    // generieke tabel in de modal (XS 82-87, S 88-93, M 94-99, L 100-105).
    const EU_BUST = [85, 90, 95, 98, 101, 104];
    const REF_BUST = 90; // EU 36 = ijkpunt voor hoe ruim dit model valt
    const TOL = 2;       // marge die de leverancier zelf aangeeft (2-3 cm)
    const calcFromChart = ans => {
      const body = (EU_BUST[ans.usual] ?? 95)
                 + ([-3, -2, 0, 1, 2, 4][ans.weight] ?? 0)
                 + ([-1, -0.5, 0, 0, 0.5, 1][ans.height] ?? 0);
      const target = body + (chartBust[0] - REF_BUST); // schaalt mee met de snit
      for (let i = 0; i < chartSizes.length; i++) {
        if (chartBust[i] >= target - TOL) return chartSizes[i];
      }
      return chartSizes[chartSizes.length - 1];
    };
    const calcRec = ans => {
      if (useChart) return calcFromChart(ans);
            const uScores = [0, 1, 2, 3, 4, 5];
      const hAdjs = [-0.5, -0.25, 0, 0, 0.25, 0.5];
      const wAdjs = [-0.5, -0.25, 0, 0, 0.25, 0.5];
            let i = (uScores[ans.usual] ?? 2) + (hAdjs[ans.height] ?? 0) + (wAdjs[ans.weight] ?? 0);
      return sizes[Math.round(Math.max(0, Math.min(5, i)))];
    };


        const show = n => {
      step = n;
      steps.forEach((s, i) => s.style.display = i === n ? '' : 'none');
      const nextBtn = quiz.querySelector('[data-ep-quiz-next]');
      if (nextBtn) nextBtn.style.display = n === steps.length - 1 ? 'none' : '';
    };

    show(0);
    quiz.querySelectorAll('.ep-quiz-opt').forEach(opt => {
      opt.addEventListener('click', () => {
               const key = opt.closest('[data-ep-quiz-step]').dataset.epQuizStep;
        answers[key] = Array.from(opt.parentElement.querySelectorAll('.ep-quiz-opt')).indexOf(opt);
        opt.parentElement.querySelectorAll('.ep-quiz-opt').forEach(o => o.classList.toggle('is-selected', o === opt));
        quiz.querySelector('[data-ep-quiz-next]').disabled = false;
                const rec = calcRec(answers);
        quiz.dataset.recommendation = rec;
        const rEl = quiz.querySelector('.ep-quiz-result-size');
        if (rEl) rEl.textContent = rec;
        const aBtn = quiz.querySelector('[data-ep-quiz-apply]');
        if (aBtn) aBtn.textContent = epT('quiz_apply', 'Appliquer la taille __SIZE__').replace('__SIZE__', rec);
        const nEl = quiz.querySelector('.ep-quiz-note');
        if (nEl) nEl.innerHTML = epT('quiz_note', '<strong>Notre conseil :</strong> d\'après votre morphologie, la taille <strong>__SIZE__</strong> offre le meilleur tombé.').replace('__SIZE__', rec);

      });
    });
    quiz.querySelector('[data-ep-quiz-next]')?.addEventListener('click', () => {
      if (step < steps.length - 1) {
        show(step + 1);
        quiz.querySelector('[data-ep-quiz-next]').disabled = true;
      }
    });
    quiz.querySelector('[data-ep-quiz-apply]')?.addEventListener('click', () => {
      const rec = quiz.dataset.recommendation || 'M';
      try { if (window.posthog) posthog.capture('size_quiz_applied', { size: rec }); } catch(e){}
      const findSize = v => ['Taille', 'Size', 'Tamanho', 'Talla', 'Tamaño']
        .map(n => document.querySelector('[data-ep-option="' + n + '"][data-ep-value="' + v + '"]')).find(Boolean) || null;
      const ALIAS = { XXL: '2XL', '2XL': 'XXL', XXXL: '3XL', '3XL': 'XXXL', XXXXL: '4XL', '4XL': 'XXXXL' };
      const sizeBtn = findSize(rec) || (ALIAS[rec] ? findSize(ALIAS[rec]) : null);
      if (sizeBtn) sizeBtn.click();
      hideQuiz();
    });
  }

  // ===== FAQ: native <details> — no JS needed, but close others on open if desired =====

  // ===== Add to cart (AJAX) =====
  const productForm = document.querySelector('[data-ep-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(productForm);
      const btn = productForm.querySelector('[data-ep-atc]');
      const originalText = btn.querySelector('[data-ep-atc-label]').textContent;
      btn.querySelector('[data-ep-atc-label]').textContent = epT('adding', 'Ajout...');
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!res.ok) throw new Error('add failed');
        btn.querySelector('[data-ep-atc-label]').textContent = epT('added', '✓ Ajouté');
setTimeout(() => {
  btn.querySelector('[data-ep-atc-label]').textContent = originalText;
  btn.disabled = false;
}, 800);

// Trigger Impulse cart drawer
try {
  const cartData = await (await fetch('/cart.js')).json();
  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
    detail: { response: cartData, trigger: btn },
    bubbles: true
  }));
} catch(e) {
  const cartTrigger = document.querySelector('.js-drawer-open-cart');
  if (cartTrigger) cartTrigger.click();
  else window.location = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
}

      } catch (err) {
        btn.querySelector('[data-ep-atc-label]').textContent = originalText;
        btn.disabled = false;
        alert(epT('error', 'Erreur — veuillez réessayer.'));
      }
    });
  }

})();

/* ============================================================
   CART progress bar — append to estee-paris.js
   ============================================================ */

/* Bundle progress bar — test variant baked in (A/B test winner, 2026-06-08) */
function epFmtEur(cents) {
  var n = Number(cents);
  if (!isFinite(n) || n <= 0) return '';
  return (n / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
}

window.epUpdateProgress = async function(count) {
  var totalCents = 0;
  var savingsCents = 0;
  try {
    var cart = await fetch('/cart.js', { cache: 'no-store' }).then(function(r){ return r.json(); });
    count = cart.item_count;
    totalCents = cart.total_price;
    savingsCents = cart.total_discount;
    var el = document.querySelector('.ep-cart-items[data-cart-subtotal]');
    if (el) {
      el.setAttribute('data-cart-subtotal', String(totalCents));
      el.setAttribute('data-cart-savings', String(savingsCents));
      el.setAttribute('data-count', String(count));
    }
  } catch (_) {
    count = parseInt(count, 10) || 0;
    var subEl = document.querySelector('.ep-cart-items[data-cart-subtotal]');
    var savEl = document.querySelector('.ep-cart-items[data-cart-savings]');
    var t = subEl ? parseInt(subEl.getAttribute('data-cart-subtotal'), 10) : 0;
    var s = savEl ? parseInt(savEl.getAttribute('data-cart-savings'), 10) : 0;
    totalCents = isFinite(t) && t > 0 ? t : 0;
    savingsCents = isFinite(s) && s > 0 ? s : 0;
  }
  var fmtEur = epFmtEur;
  var preDiscountCents = totalCents + savingsCents;
  // count=1 → projectie naar 2 items: 15% × (avg per item × 2) = totalCents × 0.30
  var save15 = Math.round(totalCents * 0.30);
  // count=2 → projectie naar 3 items: 25% × pre_discount × 1.5 − huidige korting (= extra besparing)
  var save25_extra = Math.round(preDiscountCents * 1.5 * 0.25 - savingsCents);

  document.querySelectorAll('.ep-cart').forEach(function(scope) {
    var fill = scope.querySelector('[data-progress-fill]');
    var text = scope.querySelector('[data-progress-text]');
    var dots = scope.querySelectorAll('[data-mile-dot]');
    var lbls = scope.querySelectorAll('.ep-mile-lbl');

    var pct = 0, activeIdx = 0;
    if (count >= 3)      { pct = 100; activeIdx = 2; }
    else if (count == 2) { pct = 50;  activeIdx = 1; }
    else                 { pct = 0;   activeIdx = 0; }

    if (fill) fill.style.width = pct + '%';

    dots.forEach(function(dot, i) {
      dot.classList.remove('is-reached', 'is-current');
      if (i < activeIdx) dot.classList.add('is-reached');
      else if (i === activeIdx) dot.classList.add('is-current');
    });
    lbls.forEach(function(lbl, i) { lbl.classList.toggle('is-active', i === activeIdx); });

    if (!text) return;
    text.classList.remove('is-success');

    if (count === 0) {
      text.innerHTML = epT('prog_t0', 'Ajoutez <strong>2 articles</strong> et économisez jusqu’à <strong>15%</strong> · Livraison offerte');
    } else if (count === 1) {
      var hint1 = save15 > 0 ? ' (≈ ' + fmtEur(save15) + ')' : '';
      text.innerHTML = epT('prog_t1', 'Ajoutez <strong>1 article</strong> et économisez <strong>15%</strong>') + hint1 + ' ' + epT('prog_ship_tail', '· Livraison offerte');
    } else if (count === 2) {
      text.classList.add('is-success');
      var hint2 = save25_extra > 0 ? ' ' + epT('prog_hint_extra', 'supplémentaires (≈ __AMT__)').replace('__AMT__', fmtEur(save25_extra)) : '';
      text.innerHTML = epT('prog_j2', '✓ −15% appliqué · Ajoutez <strong>1 article</strong> pour <strong>10%</strong>') + hint2;
    } else {
      text.classList.add('is-success');
      text.innerHTML = epT('prog_j3', '✓ <strong>−25%</strong> appliqué · Livraison offerte');
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.ep-cart [data-cart-count]');
  if (el) window.epUpdateProgress(el.textContent.trim());
});

document.addEventListener('cart:updated', function() { window.epUpdateProgress(0); });
document.addEventListener('cart.requestComplete', function() { window.epUpdateProgress(0); });
